import consumer from "../.././channels/consumer"

document.addEventListener('turbolinks:load', function() {
  const cancellationEl = document.getElementById('js-subscription-cancellation');

  if (cancellationEl) {
    let userId = cancellationEl.dataset.id

    consumer.subscriptions.create({ channel: "UserSubscriptionCancellationChannel", user_id: userId }, {
      received(data) {
        if (data.type === 'apply_discount') {
          if (data.status === 'error') {
            window.location.href = `/account/langua_settings/${userId}/edit?active_tab=subscription&apply_discount=error`;
          } else if (data.status === 'success') {
            window.location.href = `/account/langua_settings/${userId}/edit?active_tab=subscription&apply_discount=success`;
          }
        } else if (data.type === 'cancel_subscription') {
          if (data.status === 'error') {
            window.location.href = `/account/langua_settings/${userId}/edit?active_tab=subscription&cancel_subscription=error`;
          } else if (data.status === 'success') {
            window.location.href = `/account/langua_settings/${userId}/edit?active_tab=subscription&cancel_subscription=success`;
          }
        } else if (data.type === 'stay_subscribed') {
          window.location.href = `/account/langua_settings/${userId}/edit?active_tab=subscription&stay_subscribed=success`;
        }
      }
    });
  }
})
